export const visit = (vm, at) => {
at({ "lt": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Kilo tinklo ry\u0161io problema.", "message": "Patikrinkite ry\u0161\u012F ir bandykite dar kart\u0105.", "button": "Bandyti dar kart\u0105" } } } } });
};